
<div container *visible="loadState.isCompleted && studentAmiramTests.length > 0; transition 'route'">
  <h4 i18n>להלן המועדים אליהם נרשמת</h4>

  <section *ngIf="!appLayout.isMobile"
    class="table-responsive mat-elevation-z2">
    <table mat-table
      [dataSource]="studentAmiramTests"
      [ui-column-width]="[120,100,100,170]">

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>
          תאריך
        </th>

        <td mat-cell *matCellDef="let row;">
          {{ row?.testStartDate | date: 'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="hour">
        <th mat-header-cell *matHeaderCellDef i18n>
          שעה
        </th>

        <td mat-cell *matCellDef="let row;">
          {{ row?.testStartDate | date: 'HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="campus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>
          קמפוס
        </th>

        <td mat-cell *matCellDef="let row;">
          {{ row?.instituteName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>

        <td mat-cell *matCellDef="let row;">
          <a [href]="downloadPath(row)"
            target="_blank"
            mat-raised-button
            color="primary">
            <mat-icon>cloud_download</mat-icon>
            &nbsp;&nbsp;
            <span i18n>הורדת האישור</span>
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </section>

  <div *ngIf="appLayout.isMobile">
    <div class="registration-entry-card amiram-test-card" *ngFor="let row of studentAmiramTests">
      <div class="registration-entry-card__body">
        <span class="registration-entry-card__title">{{ row?.testStartDate | date: 'HH:mm' }} | {{ row?.testStartDate | date: 'dd/MM/yyyy' }}</span>
        <span class="registration-entry-card__badge">{{ row?.instituteName }}</span>
      </div>

      <div class="amiram-test-card__action">
        <a [href]="downloadPath(row)"
          target="_blank"
          mat-stroked-button
          color="primary"
          class="ui-outlined">
          <mat-icon>cloud_download</mat-icon>
          &nbsp;&nbsp;
          <span i18n>הורדת האישור</span>
        </a>
      </div>
    </div>
  </div>

</div>
